import { CheckedIcon } from 'assests/GmsIcons';
import React from 'react';

type TStep = {
    number: number;
    title: string;
    isActive: boolean;
    isCompleted: boolean;
}

type TStepperProps = {
    currentStep: number;
    onStepChange: (step: number) => void;
    steps: TStep[];
    payload: TRecategorizePayload
}

const Stepper = ({ currentStep, onStepChange, steps, payload }: TStepperProps) => {
    const handleStepClick = (stepNumber: number) => {
        if (stepNumber <= currentStep || stepNumber === currentStep + 1) {
            onStepChange(stepNumber);
        }
    };

    const isStepDisabled = (step: TStep) => {
        const isInvalidStep = (!step.isCompleted && step.number > currentStep + 1);
        const isPayloadInvalid = payload?.target_category === null;
        return isInvalidStep || isPayloadInvalid;
    };

    return (
        <div className="tw-w-full tw-max-w-xl tw-mx-auto">
            <div className="tw-flex tw-items-center tw-justify-between">
                {steps.map((step, index) => (
                <React.Fragment key={step.number}>
                    <div className="tw-flex tw-flex-col tw-items-center">
                        <button
                            onClick={() => handleStepClick(step.number)}
                                disabled={true}
                            className={`
                                tw-relative 
                                tw-flex tw-items-center tw-justify-center 
                                tw-w-8 tw-h-8 tw-rounded-full tw-font-medium tw-border-2 
                                tw-transform hover:tw-scale-110 
                                tw-transition-all tw-duration-300 tw-ease-in-out
                                ${
                                    step.isCompleted
                                        ? 'tw-border-[#002F67] tw-bg-[#002F67] tw-text-white tw-cursor-pointer animate-bounce' 
                                        : step.isActive
                                        ? 'tw-border-[#002F67] tw-bg-[#002F67] tw-text-white tw-cursor-pointer animate-fade-in' 
                                        : 'tw-border-[#6D788C] tw-text-[#6D788C] tw-text-sm'
                                }
                                ${step.number <= currentStep + 1 ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed'}
                            `}
                        >
                            <div 
                                className={`
                                    tw-absolute tw-inset-0 
                                    tw-flex tw-items-center tw-justify-center 
                                    tw-transition-all tw-duration-300 tw-ease-in-out
                                    ${step.isCompleted ? 'tw-opacity-0 tw-scale-75' : 'tw-opacity-100 tw-scale-100'}`}
                            >
                                {step.number}
                            </div>
                            <div 
                                className={`
                                    tw-absolute tw-inset-0 
                                    tw-flex tw-items-center tw-justify-center 
                                    tw-transition-all tw-duration-300 tw-ease-in-out
                                    ${step.isCompleted ? 'tw-opacity-100 tw-scale-100' : 'tw-opacity-0 tw-scale-75'}`}
                            >
                                <CheckedIcon />
                            </div>
                        </button>
                        <div
                            className={`
                                tw-mt-2 tw-text-sm
                                tw-transition-colors tw-duration-300 tw-ease-in-out
                                ${step.isCompleted || step.isActive ? 'tw-text-[#002F67]' : 'tw-text-gray-500'}`}
                        >
                            {step.title}
                        </div>
                    </div>
                    {index < steps.length - 1 && (
                        <div className="tw-flex-1 tw-mx-4">
                            <div className="tw-relative tw-h-0.5">
                                <div className="tw-absolute tw-inset-0 tw-bg-gray-300" />
                                <div
                                    className={`
                                        tw-absolute tw-inset-0 
                                        tw-bg-[#002F67]
                                        tw-transition-transform tw-duration-500 tw-ease-in-out
                                        tw-origin-left
                                        ${step.isCompleted ? 'tw-scale-x-100' : 'tw-scale-x-0'}
                                    `}
                                />
                            </div>
                        </div>
                    )}
                </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default Stepper;